ThangTypeConstants =
  heroes:
    captain: '529ec584c423d4e83b000014'
    knight: '529ffbf1cf1818f2be000001'
    samurai: '53e12be0d042f23505c3023b'
    raider: '55527eb0b8abf4ba1fe9a107'
    goliath: '55e1a6e876cb0948c96af9f8'
    guardian: '566a058620de41290036a745'
    ninja: '52fc0ed77e01835453bd8f6c'
    'forest-archer': '5466d4f2417c8b48a9811e87'
    trapper: '5466d449417c8b48a9811e83'
    pixie: '579a619382f2401f001cd5b4'
    assassin: '566a2202e132c81f00f38c81'
    librarian: '52fbf74b7e01835453bd8d8e'
    'potion-master': '52e9adf7427172ae56002172'
    sorcerer: '52fd1524c7e6cf99160e7bc9'
    necromancer: '55652fb3b9effa46a1f775fd'
    'master-wizard': ''
    duelist: '57588f09046caf2e0012ed41'
    champion: '575848b522179b2800efbfbf'
    'code-ninja': '58192d484954d56144a7062f'
    stalwart: '5a576ec52db68a00269b7a08'
  heroClasses:
    Warrior: ['champion', 'duelist', 'captain', 'knight', 'samurai', 'raider', 'goliath', 'guardian', 'code-ninja', 'stalwart']
    Ranger: ['ninja', 'forest-archer', 'trapper', 'pixie', 'assassin']
    Wizard: ['librarian', 'potion-master', 'sorcerer', 'necromancer', 'master-wizard']
  items:
    'simple-boots': '53e237bf53457600003e3f05'

module.exports = ThangTypeConstants



// WEBPACK FOOTER //
// ./app/lib/ThangTypeConstants.coffee